{
  "admin.guard": {
    "loading": "Carregando…"
  },
  "admin.layout": {
    "nav": {
      "label": "Principal",
      "home": "Painel",
      "clinics": "Clínicas",
      "staff": "Equipe",
      "profile": "Perfil",
      "password": "Alterar senha"
    },
    "logout": "Sair",
    "logoutFailed": "Não foi possível sair. Tente novamente."
  },
  "admin.shell": {
    "brand": "Takove",
    "skipToContent": "Pular para o conteúdo"
  },
  "admin.clinicNew": {
    "title": "Nova clínica",
    "name": "Nome da clínica",
    "timezone": {
      "label": "Fuso horário",
      "hint": "Escolha com cuidado: o fuso não pode ser alterado depois. Um erro é corrigido pela operação, enquanto a clínica não tiver consultas.",
      "zone": {
        "saoPaulo": "São Paulo, Rio, Brasília (UTC−3)",
        "noronha": "Fernando de Noronha (UTC−2)",
        "belem": "Belém (UTC−3)",
        "fortaleza": "Fortaleza (UTC−3)",
        "recife": "Recife (UTC−3)",
        "araguaina": "Araguaína (UTC−3)",
        "maceio": "Maceió (UTC−3)",
        "bahia": "Salvador, Bahia (UTC−3)",
        "campoGrande": "Campo Grande (UTC−4)",
        "cuiaba": "Cuiabá (UTC−4)",
        "portoVelho": "Porto Velho (UTC−4)",
        "boaVista": "Boa Vista (UTC−4)",
        "manaus": "Manaus (UTC−4)",
        "eirunepe": "Eirunepé (UTC−5)",
        "rioBranco": "Rio Branco (UTC−5)"
      }
    },
    "owner": {
      "legend": "Responsável (proprietário)",
      "kind": "Conta do proprietário",
      "kindNew": "Nova conta de equipe",
      "kindExisting": "Conta de equipe existente",
      "email": "E-mail do proprietário",
      "emailExistingHint": "A conta já precisa existir e estar ativa.",
      "name": "Nome do proprietário"
    },
    "cro": {
      "number": "Número do CRO",
      "uf": "UF do CRO",
      "noUf": "UF"
    },
    "submit": "Criar clínica",
    "error": {
      "emailTaken": "Já existe uma conta de equipe com este e-mail.",
      "ownerNotFound": "Não existe conta de equipe com este e-mail.",
      "ownerDisabled": "Esta conta de equipe está desativada.",
      "croPair": "Informe o número e a UF do CRO, ou deixe os dois em branco.",
      "generic": "Não foi possível criar a clínica. Tente novamente."
    }
  },
  "admin.clinic": {
    "back": "Todas as clínicas",
    "created": "Clínica {{name}} criada.",
    "createdNewOwner": "Como o proprietário é uma conta nova, gere o link de senha dele em Equipe.",
    "statusTitle": "Situação",
    "createdAt": "Criada em {{date}}",
    "closedSince": "Fechada desde {{date}}. Os membros só consultam; nada foi apagado.",
    "suspendedSince": "Suspensa desde {{date}}. Os membros não conseguem acessar a clínica.",
    "action": {
      "close": "Fechar clínica",
      "reopen": "Reabrir clínica",
      "suspend": "Suspender clínica",
      "unsuspend": "Retirar suspensão"
    },
    "reason": {
      "closeTitle": "Fechar clínica",
      "suspendTitle": "Suspender clínica",
      "label": "Motivo",
      "hint": "Fica registrado na auditoria.",
      "confirmClose": "Confirmar fechamento",
      "confirmSuspend": "Confirmar suspensão",
      "cancel": "Cancelar",
      "required": "Informe o motivo."
    },
    "done": {
      "closed": "Clínica fechada.",
      "reopened": "Clínica reaberta.",
      "suspended": "Clínica suspensa.",
      "unsuspended": "Suspensão retirada."
    },
    "error": {
      "load": "Não foi possível carregar a clínica. Tente novamente.",
      "notFound": "Clínica não encontrada.",
      "action": "Não foi possível concluir a ação. Tente novamente."
    }
  },
  "admin.clinics": {
    "title": "Clínicas",
    "new": "Nova clínica",
    "search": "Buscar por nome",
    "searchSubmit": "Buscar",
    "empty": "Nenhuma clínica ainda.",
    "emptySearch": "Nenhuma clínica encontrada para essa busca.",
    "hasMore": "Há mais clínicas do que as exibidas. Refine a busca.",
    "col": {
      "name": "Nome",
      "status": "Situação",
      "members": "Membros",
      "created": "Criada em"
    },
    "status": {
      "active": "Ativa",
      "closed": "Fechada",
      "suspended": "Suspensa"
    },
    "error": {
      "load": "Não foi possível carregar as clínicas. Tente novamente."
    }
  },
  "admin.clinicIdentity": {
    "title": "Identidade da clínica",
    "hint": "Somente o proprietário da clínica edita estes dados; aqui você só consulta.",
    "notInformed": "Não informado",
    "whatsapp": "WhatsApp",
    "cro": "CRO {{number}}/{{uf}}",
    "croNoUf": "CRO {{number}}",
    "fields": {
      "legalName": "Razão social",
      "cnpj": "CNPJ",
      "croRegistration": "Inscrição CRO da clínica",
      "phone": "Telefone",
      "email": "E-mail",
      "address": "Endereço",
      "technicalManager": "Responsável técnico"
    }
  },
  "admin.clinicMembers": {
    "title": "Membros ativos",
    "empty": "Esta clínica não tem membros ativos.",
    "col": {
      "name": "Nome",
      "email": "E-mail",
      "roles": "Papéis",
      "since": "Desde",
      "actions": "Ações"
    },
    "role": {
      "owner": "Proprietário",
      "dentist": "Dentista"
    },
    "technicalManager": "Responsável técnico",
    "action": {
      "roles": "Alterar papéis",
      "rolesFor": "Alterar papéis de {{name}}",
      "end": "Encerrar vínculo",
      "endFor": "Encerrar vínculo de {{name}}",
      "setTm": "Definir como responsável técnico",
      "setTmFor": "Definir como responsável técnico: {{name}}",
      "clearTm": "Remover responsável técnico",
      "clearTmFor": "Remover responsável técnico: {{name}}"
    },
    "add": {
      "title": "Adicionar membro",
      "email": "E-mail da conta de equipe",
      "emailHint": "A conta precisa existir. Crie-a antes em Equipe, se necessário.",
      "roles": "Papéis do novo membro",
      "submit": "Adicionar membro"
    },
    "edit": {
      "title": "Alterar papéis de {{name}}",
      "roles": "Papéis de {{name}}",
      "save": "Salvar papéis",
      "cancel": "Cancelar"
    },
    "end": {
      "title": "Encerrar vínculo de {{name}}",
      "body": "A pessoa perde o acesso a esta clínica. O histórico é mantido e a conta continua existindo.",
      "confirm": "Confirmar encerramento",
      "cancel": "Cancelar"
    },
    "done": {
      "added": "{{name}} foi adicionado à clínica.",
      "roles": "Papéis de {{name}} atualizados.",
      "ended": "Vínculo de {{name}} encerrado.",
      "tmSet": "{{name}} é o responsável técnico.",
      "tmCleared": "{{name}} deixou de ser o responsável técnico."
    },
    "error": {
      "notFound": "Não existe conta de equipe com este e-mail.",
      "disabled": "Esta conta está desativada.",
      "cro": "O papel de dentista exige um CRO na conta.",
      "alreadyMember": "Esta conta já é membro ativo desta clínica.",
      "lastOwner": "Uma clínica precisa manter ao menos um proprietário ativo.",
      "tmIneligible": "O responsável técnico precisa ser dentista com CRO.",
      "generic": "Não foi possível concluir a ação. Tente novamente.",
      "futureAppointments_one": "Este membro tem {{count}} agendamento futuro. Reatribua ou cancele-o antes de continuar.",
      "futureAppointments_many": "Este membro tem {{count}} de agendamentos futuros. Reatribua ou cancele-os antes de continuar.",
      "futureAppointments_other": "Este membro tem {{count}} agendamentos futuros. Reatribua ou cancele-os antes de continuar.",
      "rolesRequired": "Escolha ao menos um papel."
    }
  },
  "admin.home": {
    "title": "Painel",
    "welcome": "Olá, {{name}}."
  },
  "admin.login": {
    "forgot": "Esqueceu a senha?",
    "title": "Entrar",
    "email": "E-mail",
    "password": "Senha",
    "submit": "Entrar",
    "passwordSet": "Senha definida. Entre com a nova senha.",
    "error": {
      "invalid": "E-mail ou senha incorretos.",
      "throttled": "Muitas tentativas. Aguarde um minuto e tente novamente.",
      "generic": "Não foi possível entrar. Tente novamente."
    }
  },
  "admin.notFound": {
    "title": "Página não encontrada",
    "message": "A página que você procurou não existe ou foi movida.",
    "home": "Ir para o início"
  },
  "admin.password": {
    "title": "Alterar senha",
    "current": "Senha atual",
    "new": "Nova senha",
    "confirm": "Confirmar nova senha",
    "submit": "Alterar senha",
    "changed": "Senha alterada. Suas outras sessões foram encerradas.",
    "error": {
      "wrongCurrent": "A senha atual está incorreta.",
      "tooShort": "A nova senha precisa ter pelo menos {{min}} caracteres.",
      "unchanged": "A nova senha deve ser diferente da atual.",
      "mismatch": "As senhas não coincidem.",
      "throttled": "Muitas tentativas. Aguarde um minuto e tente novamente.",
      "generic": "Não foi possível alterar a senha. Tente novamente."
    }
  },
  "admin.profile": {
    "title": "Perfil",
    "email": "E-mail",
    "emailHint": "O e-mail não pode ser alterado aqui.",
    "name": "Nome",
    "locale": "Idioma",
    "dateFormat": "Formato de data",
    "clock": "Relógio",
    "dateFormats": {
      "DMY": "Dia/mês/ano",
      "MDY": "Mês/dia/ano",
      "YMD": "Ano/mês/dia"
    },
    "clocks": {
      "24h": "24 horas",
      "12h": "12 horas"
    },
    "submit": "Salvar",
    "saved": "Perfil salvo.",
    "error": "Não foi possível salvar o perfil. Tente novamente."
  },
  "admin.staffNew": {
    "title": "Nova conta de equipe",
    "email": "E-mail",
    "name": "Nome",
    "cro": {
      "legend": "Registro no CRO (opcional)",
      "number": "Número do CRO",
      "uf": "UF do CRO",
      "noUf": "UF"
    },
    "submit": "Criar conta",
    "error": {
      "emailTaken": "Já existe uma conta de equipe com este e-mail.",
      "croPair": "Informe o número e a UF do CRO, ou deixe os dois em branco.",
      "generic": "Não foi possível criar a conta. Tente novamente."
    }
  },
  "admin.staff": {
    "title": "Contas de equipe",
    "new": "Nova conta",
    "created": "Conta de {{name}} criada. Gere o link de definição de senha para entregar à pessoa.",
    "search": "Buscar por nome ou e-mail",
    "searchSubmit": "Buscar",
    "empty": "Nenhuma conta de equipe ainda.",
    "emptySearch": "Nenhuma conta encontrada para essa busca.",
    "hasMore": "Há mais contas do que as exibidas. Refine a busca.",
    "col": {
      "name": "Nome",
      "email": "E-mail",
      "cro": "CRO",
      "status": "Situação",
      "lastLogin": "Último acesso",
      "actions": "Ações"
    },
    "status": {
      "active": "Ativa",
      "pending": "Aguardando senha",
      "disabled": "Desativada"
    },
    "action": {
      "link": "Gerar link de senha de {{name}}",
      "disable": "Desativar {{name}}",
      "enable": "Reativar {{name}}"
    },
    "link": {
      "title": "Link de senha de {{name}}",
      "hint": "Entregue este link à pessoa. Ele aparece só agora, vale para um único uso e expira em {{expires}}. Gerar outro link invalida este.",
      "choose": "Como entregar o link a {{name}}? Gerar um novo link invalida o anterior.",
      "email": "Enviar por e-mail",
      "sent": "Link enviado para {{email}}, válido até {{expires}}.",
      "sentHint": "Se não chegar, gere um novo link com Copiar link: ele invalida o enviado.",
      "close": "Fechar",
      "label": "Link",
      "copy": "Copiar link",
      "copied": "Link copiado."
    },
    "confirm": {
      "title": "Desativar {{name}}?",
      "future_one": "{{name}} tem {{count}} agendamento futuro. Desativar a conta não o cancela nem o reatribui: ele continua na agenda sem profissional que atenda. Reatribua ou cancele-o antes, ou desative mesmo assim.",
      "future_many": "{{name}} tem {{count}} de agendamentos futuros. Desativar a conta não os cancela nem os reatribui: eles continuam na agenda sem profissional que atenda. Reatribua ou cancele-os antes, ou desative mesmo assim.",
      "future_other": "{{name}} tem {{count}} agendamentos futuros. Desativar a conta não os cancela nem os reatribui: eles continuam na agenda sem profissional que atenda. Reatribua ou cancele-os antes, ou desative mesmo assim.",
      "submit": "Desativar mesmo assim",
      "cancel": "Cancelar"
    },
    "error": {
      "load": "Não foi possível carregar as contas. Tente novamente.",
      "action": "Não foi possível concluir a ação. Tente novamente."
    }
  },
  "hub.guard": {
    "loading": "Carregando…"
  },
  "hub.layout": {
    "clinicNav": "Clínica",
    "patients": "Pacientes",
    "agenda": "Agenda",
    "settings": "Configurações",
    "logout": "Sair",
    "logoutFailed": "Não foi possível sair. Tente novamente.",
    "switchClinic": "{{name}}, trocar de clínica",
    "allClinics": "Todas as clínicas"
  },
  "hub.shell": {
    "brand": "Takove",
    "skipToContent": "Pular para o conteúdo"
  },
  "hub.agenda": {
    "title": "Agenda",
    "subtitle": "Consultas da clínica por dia ou por semana.",
    "loading": "Carregando a agenda…",
    "loadFailed": "Não foi possível carregar a agenda.",
    "retry": "Tentar novamente",
    "noAccess": "Você não tem acesso à agenda desta clínica.",
    "weekday": {
      "1": "Segunda-feira",
      "2": "Terça-feira",
      "3": "Quarta-feira",
      "4": "Quinta-feira",
      "5": "Sexta-feira",
      "6": "Sábado",
      "7": "Domingo"
    },
    "toolbar": {
      "label": "Opções da agenda",
      "view": "Visualização",
      "day": "Dia",
      "week": "Semana",
      "professional": "Profissional",
      "allProfessionals": "Toda a clínica",
      "today": "Hoje",
      "prevDay": "Dia anterior",
      "nextDay": "Próximo dia",
      "prevWeek": "Semana anterior",
      "nextWeek": "Próxima semana",
      "new": "Novo agendamento",
      "schedule": "Horários e bloqueios",
      "rebooking": "Reagendamentos pendentes",
      "mode": "Modo de exibição",
      "grid": "Grade",
      "list": "Lista",
      "rangeDay": "{{from, date}}",
      "rangeWeek": "{{from, date}} a {{to, date}}"
    },
    "filter": {
      "warningsOnly": "Mostrar apenas agendamentos com avisos",
      "warningCount_one": "{{count}} com aviso",
      "warningCount_other": "{{count}} com avisos"
    },
    "list": {
      "label": "Agenda do período",
      "dayHeading": "{{weekday}}, {{date, date}}",
      "today": "Hoje",
      "closed": "Clínica fechada",
      "emptyDay": "Sem agendamentos",
      "noWarnings": "Nenhum agendamento com aviso neste período.",
      "range": "{{start, time}} – {{end, time}}",
      "sentence": "{{patient}}, {{start, time}} às {{end, time}}, {{professional}}, {{status}}"
    },
    "grid": {
      "corner": "Horário",
      "dayLabel": "Agenda de {{weekday}}, {{date, date}}",
      "weekLabel": "Agenda da semana de {{name}}, {{from, date}} a {{to, date}}",
      "dateLine": "{{date, date}}",
      "details": "{{professional}}, {{weekday}}, {{date, date}}, {{start, time}} às {{end, time}}",
      "newSlot": "Novo agendamento, {{professional}}, {{weekday}}, {{date, date}}, {{time, time}}",
      "slotClosed": "fora do horário da clínica",
      "slotOff": "fora do expediente do profissional",
      "notes": "Bloqueios do período",
      "noteLine": "{{date, date}}: {{note}}",
      "summaryLabel": "Resumo da semana: agendamentos por profissional e dia",
      "summaryHint": "Escolha um profissional para ver a semana em grade, ou abra um dia.",
      "summaryProfessional": "Profissional",
      "summaryCell_one": "{{professional}}, {{weekday}}, {{date, date}}: {{count}} agendamento. Abrir o dia",
      "summaryCell_other": "{{professional}}, {{weekday}}, {{date, date}}: {{count}} agendamentos. Abrir o dia"
    },
    "announce": {
      "shown_one": "{{count}} agendamento no período",
      "shown_other": "{{count}} agendamentos no período",
      "warnings_one": "{{count}} agendamento com aviso",
      "warnings_other": "{{count}} agendamentos com avisos"
    },
    "status": {
      "scheduled": "Agendado",
      "confirmed": "Confirmado",
      "arrived": "Chegou",
      "in_progress": "Em atendimento",
      "completed": "Concluído",
      "cancelled": "Cancelado",
      "no_show": "Faltou"
    },
    "flag": {
      "outside_opening_hours": "Fora do horário",
      "outside_working_hours": "Fora do expediente",
      "in_block": "Em bloqueio",
      "outcomePending": "Desfecho pendente",
      "freed": "Horário liberado"
    },
    "block": {
      "clinic": "Clínica fechada: {{what}}",
      "professional": "Bloqueio de {{name}}: {{what}}",
      "professionalUnknown": "Bloqueio de profissional: {{what}}",
      "inGrid": "Bloqueio: {{what}}",
      "withHours": "{{note}}, {{from, time}} – {{to, time}}",
      "reason": {
        "vacation": "Férias",
        "absence": "Ausência",
        "training": "Capacitação",
        "holiday": "Feriado",
        "closure": "Fechamento",
        "other": "Outro"
      }
    },
    "sheet": {
      "createTitle": "Novo agendamento",
      "create": "Criar agendamento",
      "noProfessionals": "Nenhum profissional disponível para receber agendamentos.",
      "editTitle": "Agendamento de {{patient}}",
      "close": "Fechar",
      "summary": {
        "status": "Status",
        "day": "Dia",
        "time": "Horário",
        "professional": "Profissional",
        "patient": "Paciente",
        "reason": "Motivo"
      },
      "statusChanged": "Status alterado para {{status}}.",
      "statusGroup": "Alterar status",
      "noActions": "Nenhuma mudança de status disponível agora.",
      "cancelGroup": "Motivo do cancelamento",
      "noShowGroup": "Motivo da falta",
      "reasonLabel": "Motivo",
      "confirmCancel": "Confirmar cancelamento",
      "confirmNoShow": "Confirmar falta",
      "back": "Voltar",
      "reasonRequired": "Escolha um motivo.",
      "moveGroup": "Mover ou ajustar",
      "save": "Salvar alterações",
      "frozen": "Este agendamento está finalizado: os campos estão bloqueados.",
      "viewConflict": "Ver o agendamento em conflito",
      "openOtherFailed": "Não foi possível abrir o agendamento.",
      "saved": "Agendamento atualizado.",
      "created": "Agendamento criado.",
      "withWarning": "{{saved}} Atenção: {{what}}.",
      "warningAnd": " e "
    },
    "history": {
      "title": "Histórico",
      "loading": "Carregando o histórico…",
      "error": "Não foi possível carregar o histórico.",
      "retry": "Tentar novamente",
      "empty": "Nada foi registrado antes de o histórico começar a ser guardado.",
      "beforeNote": "Nada foi registrado antes do primeiro item desta lista.",
      "created": "Criado como {{status}}",
      "updated": "Alterado: {{fields}}",
      "statusChange": "Status: {{from}} → {{to}}",
      "reason": "Motivo: {{reason}}.",
      "by": "por {{name}}",
      "field": {
        "time": "horário",
        "duration": "duração",
        "professional": "profissional"
      }
    },
    "action": {
      "confirmed": "Confirmar",
      "arrived": "Marcar chegada",
      "in_progress": "Iniciar atendimento",
      "completed": "Concluir atendimento",
      "cancelled": "Cancelar agendamento",
      "no_show": "Registrar falta",
      "scheduled": "Voltar para agendado",
      "restore": "Restaurar agendamento"
    },
    "reason": {
      "cancel": {
        "patient_request": "Pedido do paciente",
        "clinic_request": "Pedido da clínica",
        "professional_unavailable": "Profissional indisponível",
        "rescheduled_elsewhere": "Remarcado em outro lugar",
        "other": "Outro motivo"
      },
      "noShow": {
        "no_contact": "Sem contato",
        "patient_reported": "Paciente avisou",
        "other": "Outro motivo"
      }
    },
    "field": {
      "patient": "Paciente",
      "patientRequired": "Escolha um paciente da lista.",
      "patientEmpty": "Nenhum paciente encontrado.",
      "patientFailed": "Não foi possível buscar pacientes.",
      "status": "Status inicial",
      "noShowReason": "Motivo da falta",
      "professional": "Profissional",
      "date": "Data",
      "start": "Início",
      "duration": "Duração",
      "durationMinutes": "Duração em minutos",
      "durationCustom": "Outra duração",
      "minutes": "{{n}} min",
      "errors": {
        "required": "Preencha este campo.",
        "grid": "Use horários de 5 em 5 minutos.",
        "range": "A duração deve ficar entre 5 e 480 minutos."
      }
    },
    "confirm": {
      "title": "Confirmar horário",
      "message": "Este horário está {{what}}.",
      "saveAnyway": "Salvar mesmo assim"
    },
    "warning": {
      "outside_opening_hours": "fora do horário de funcionamento da clínica",
      "outside_working_hours": "fora do expediente do profissional"
    },
    "error": {
      "appointment_warnings": "Este horário precisa ser confirmado.",
      "appointment_changed": "O agendamento foi alterado por outra pessoa. Feche e abra de novo para ver a versão atual.",
      "appointment_conflict_professional": "Este profissional já tem outro agendamento nesse horário.",
      "appointment_conflict_patient": "Este paciente já tem outro agendamento nesse horário.",
      "schedule_blocked": "O horário cai em um bloqueio da agenda.",
      "professional_not_eligible": "Este profissional não pode receber agendamentos.",
      "time_invalid": "Horário inválido. Confira a data, o início e a duração.",
      "transition_not_allowed": "Esta mudança de status não é permitida.",
      "time_guard_failed": "Esta mudança de status não é permitida neste horário.",
      "reason_required": "Escolha um motivo.",
      "reason_invalid": "Escolha um motivo válido.",
      "initial_status_invalid": "Este status inicial não é permitido para o horário escolhido.",
      "appointment_frozen": "Este agendamento está finalizado e não pode ser alterado.",
      "field_not_editable": "Este campo não pode ser alterado neste status.",
      "clinic_closed": "A clínica está encerrada; não é possível alterar a agenda.",
      "patient_archived": "O cadastro deste paciente está arquivado.",
      "appointment_not_found": "Agendamento não encontrado.",
      "patient_not_found": "Paciente não encontrado.",
      "unknown": "Não foi possível concluir. Tente novamente."
    }
  },
  "hub.rebooking": {
    "title": "Reagendamentos pendentes",
    "subtitle": "Pacientes com consulta cancelada ou faltada e sem novo agendamento. Cada paciente sai da lista quando é reagendado ou 30 dias depois.",
    "loading": "Carregando a lista…",
    "loadFailed": "Não foi possível carregar a lista.",
    "retry": "Tentar novamente",
    "noAccess": "Você não tem acesso à agenda desta clínica.",
    "back": "Voltar para a agenda",
    "listHeading": "Pacientes para reagendar",
    "listLabel": "Pacientes para reagendar",
    "empty": "Nenhum paciente aguardando reagendamento.",
    "professional": "Profissional",
    "allProfessionals": "Toda a clínica",
    "none": "Nenhum paciente para reagendar",
    "count_one": "{{count}} paciente para reagendar",
    "count_other": "{{count}} pacientes para reagendar",
    "when": "{{weekday}}, {{date, date}}, {{start, time}} – {{end, time}}",
    "reason": "Motivo: {{reason}}",
    "next": "Próximo agendamento: {{date, date}}, {{time, time}}, {{professional}}",
    "rebook": "Reagendar",
    "rebookName": "Reagendar {{name}}",
    "more": "Carregar mais",
    "moreFailed": "Não foi possível carregar mais pacientes.",
    "loadedMore": "{{count}} pacientes na lista",
    "cleared": "{{name}} foi reagendado(a) para {{date, date}} às {{time, time}}. Saiu da lista.",
    "stays": "Agendamento criado para {{name}} em {{date, date}} às {{time, time}}. O paciente continua na lista: o novo horário não é posterior ao da consulta perdida.",
    "created": "Agendamento criado.",
    "openOtherFailed": "Não foi possível abrir o agendamento."
  },
  "hub.freeSlots": {
    "open": "Buscar horário livre",
    "title": "Buscar horário livre",
    "intro": "Escolha o profissional e a duração para ver os próximos horários em que dá para agendar sem aviso.",
    "professional": "Profissional",
    "duration": "Duração",
    "minutes": "{{n}} min",
    "results": "Horários livres",
    "searching": "Buscando horários livres…",
    "none": "Nenhum horário livre encontrado",
    "found_one": "{{count}} horário livre encontrado",
    "found_other": "{{count}} horários livres encontrados",
    "slot": "{{weekday}}, {{date, date}}, {{start, time}} às {{end, time}}",
    "empty": "Nenhum horário livre nos próximos 14 dias para este profissional e esta duração. Tente outra duração ou outro profissional.",
    "failed": "Não foi possível buscar os horários livres.",
    "retry": "Tentar novamente",
    "noProfessionals": "Nenhum profissional pode receber agendamentos nesta clínica.",
    "close": "Fechar"
  },
  "hub.clinics": {
    "title": "Minhas clínicas",
    "empty": "Você ainda não faz parte de nenhuma clínica.",
    "closed": "Fechada",
    "roles": {
      "owner": "Proprietário",
      "dentist": "Dentista"
    }
  },
  "hub.myClinicsLoad": {
    "loading": "Carregando suas clínicas…",
    "loadFailed": "Não foi possível carregar suas clínicas.",
    "retry": "Tentar novamente"
  },
  "hub.home": {
    "title": "Início"
  },
  "hub.login": {
    "forgot": "Esqueceu a senha?",
    "title": "Entrar",
    "email": "E-mail",
    "password": "Senha",
    "submit": "Entrar",
    "passwordSet": "Senha definida. Entre com a nova senha.",
    "error": {
      "invalid": "E-mail ou senha incorretos.",
      "throttled": "Muitas tentativas. Aguarde um minuto e tente novamente.",
      "generic": "Não foi possível entrar. Tente novamente."
    }
  },
  "hub.notFound": {
    "title": "Página não encontrada",
    "message": "A página que você procurou não existe ou foi movida.",
    "home": "Ir para o início"
  },
  "hub.patientHealth": {
    "loading": "Carregando os dados de saúde…",
    "failed": "Não foi possível carregar os dados de saúde. Tente novamente.",
    "notRecorded": "Dados de saúde ainda não registrados.",
    "reviewed": "Revisado em {{at}} por {{name}}.",
    "updated": "Última alteração em {{at}} por {{name}}.",
    "confirm": "Confirmar sem alterações",
    "confirmed": "Revisão confirmada.",
    "confirmFailed": "Não foi possível confirmar a revisão. Tente novamente.",
    "archivedReadOnly": "Cadastro arquivado. Somente leitura.",
    "edit": "Editar",
    "editCard": "Editar {{card}}",
    "saved": "{{card}} salvo.",
    "notInformed": "Não informado",
    "cards": {
      "allergies": "Alergias",
      "medications": "Medicamentos em uso",
      "conditions": "Condições de saúde",
      "pregnancy": "Gestação"
    },
    "options": {
      "allergies": {
        "unknown": "Não informado",
        "none": "Sem alergias conhecidas",
        "present": "Tem alergias"
      },
      "medications": {
        "unknown": "Não informado",
        "none": "Não usa medicamentos",
        "present": "Usa medicamentos"
      },
      "conditions": {
        "unknown": "Não informado",
        "none": "Nenhuma condição",
        "present": "Tem condições de saúde"
      },
      "pregnancy": {
        "unknown": "Não informado",
        "none": "Não está grávida",
        "present": "Está grávida"
      }
    },
    "fields": {
      "status": "Situação",
      "allergies": "Quais alergias",
      "medications": "Quais medicamentos",
      "conditions": "Condições",
      "conditionsNotes": "Outras condições e tratamento médico atual",
      "dueDate": "Data prevista do parto"
    },
    "conditions": {
      "hypertension": "Hipertensão",
      "diabetes": "Diabetes",
      "heart_disease": "Doença cardíaca",
      "bleeding_disorder": "Distúrbio de coagulação",
      "anticoagulant_use": "Uso de anticoagulante",
      "infectious_disease": "Doença infecciosa",
      "respiratory": "Doença respiratória",
      "epilepsy": "Epilepsia",
      "kidney_disease": "Doença renal",
      "liver_disease": "Doença hepática",
      "bisphosphonate_use": "Uso de bisfosfonato",
      "immunosuppression": "Imunossupressão",
      "tobacco": "Tabagismo",
      "alcohol": "Consumo de álcool"
    },
    "pregnancy": {
      "dueDate": "Parto previsto para {{date}}",
      "week_one": "{{count}}ª semana de gestação",
      "week_other": "{{count}}ª semana de gestação",
      "noDueDate": "Data prevista não informada",
      "passed": "Confira: a data prevista do parto já passou."
    },
    "form": {
      "title": "Editar {{card}}",
      "save": "Salvar",
      "cancel": "Cancelar",
      "required": "Preencha este campo.",
      "conditionsRequired": "Marque uma condição ou descreva-a nas observações.",
      "dueDateInvalid": "Data inválida.",
      "failed": "Não foi possível salvar. Tente novamente.",
      "archived": "Este cadastro foi arquivado e não pode mais ser editado."
    }
  },
  "hub.patientRecord": {
    "title": "Prontuário",
    "loading": "Carregando o prontuário…",
    "failed": "Não foi possível carregar o prontuário. Tente novamente.",
    "notFound": {
      "title": "Paciente não encontrado",
      "message": "Este cadastro não existe ou não pertence a esta clínica.",
      "back": "Voltar para a lista de pacientes"
    },
    "breadcrumb": {
      "label": "Você está em",
      "patients": "Pacientes"
    },
    "archivedBanner": "Cadastro arquivado em {{at}} por {{name}}. Motivo: {{reason}}. Somente leitura.",
    "more": {
      "label": "Mais ações",
      "text": "Mais",
      "archive": "Arquivar cadastro",
      "unarchive": "Desarquivar cadastro"
    },
    "archive": {
      "title": "Arquivar cadastro",
      "body": "O cadastro fica somente leitura e sai da lista por padrão. Você pode desarquivar depois.",
      "reason": "Motivo",
      "placeholder": "Selecione um motivo",
      "required": "Escolha um motivo.",
      "confirm": "Arquivar",
      "failed": "Não foi possível arquivar. Tente novamente.",
      "futureAppointments_one": "Este paciente tem {{count}} agendamento futuro. Cancele ou reagende antes de arquivar.",
      "futureAppointments_many": "Este paciente tem {{count}} de agendamentos futuros. Cancele ou reagende antes de arquivar.",
      "futureAppointments_other": "Este paciente tem {{count}} agendamentos futuros. Cancele ou reagende antes de arquivar.",
      "cancel": "Cancelar",
      "reasons": {
        "left_clinic": "Saiu da clínica",
        "deceased": "Falecimento",
        "duplicate": "Cadastro duplicado",
        "created_by_mistake": "Criado por engano",
        "other": "Outro"
      }
    },
    "unarchive": {
      "title": "Desarquivar cadastro",
      "body": "O cadastro volta a ser editável e a aparecer na lista.",
      "confirm": "Desarquivar",
      "failed": "Não foi possível desarquivar. Tente novamente.",
      "done": "Cadastro desarquivado."
    },
    "archivedBadge": "Arquivado",
    "header": {
      "civilName": "Nome civil: {{name}}",
      "age_one": "{{count}} ano",
      "age_other": "{{count}} anos",
      "cpf": "CPF {{cpf}}",
      "whatsapp": "WhatsApp",
      "noContact": "Sem telefone ou e-mail",
      "noticePending": "Aviso de privacidade pendente"
    },
    "tabs": {
      "label": "Seções do prontuário",
      "later": "{{tab}} (em breve: projeto {{project}})",
      "overview": "Visão geral",
      "health": "Saúde",
      "appointments": "Consultas",
      "clinical": "Prontuário clínico",
      "images": "Imagens",
      "plans": "Planos de tratamento",
      "finance": "Financeiro",
      "privacy": "Privacidade",
      "projects": {
        "agenda": "Agenda",
        "clinical": "Prontuário clínico",
        "images": "Imagens",
        "plans": "Procedimentos e planos",
        "finance": "Financeiro"
      }
    },
    "overview": {
      "notProvided": "Não informado",
      "edit": "Editar",
      "editCard": "Editar {{card}}",
      "saved": "{{card}} salvo.",
      "underageHint": "Paciente menor de 18 anos sem responsável cadastrado.",
      "notesHint": "Sem informações de saúde aqui; use a aba de saúde.",
      "yes": "Sim",
      "no": "Não",
      "cards": {
        "identification": "Identificação",
        "contact": "Contato e endereço",
        "guardian": "Responsável",
        "notes": "Observações administrativas"
      }
    },
    "fields": {
      "name": "Nome civil",
      "socialName": "Nome social",
      "sex": "Sexo",
      "birthDate": "Data de nascimento",
      "cpf": "CPF",
      "rg": "RG",
      "foreignDocument": "Documento estrangeiro",
      "nationality": "Nacionalidade (código do país, ex.: BR)",
      "foreign": "Paciente estrangeiro",
      "maritalStatus": "Estado civil",
      "profession": "Profissão",
      "phone": "Telefone",
      "phoneHasWhatsapp": "Este telefone tem WhatsApp",
      "email": "E-mail",
      "postalCode": "CEP",
      "street": "Rua",
      "number": "Número",
      "complement": "Complemento",
      "district": "Bairro",
      "state": "UF",
      "cityIbgeCode": "Cidade",
      "guardianName": "Nome do responsável",
      "guardianCpf": "CPF do responsável",
      "guardianPhone": "Telefone do responsável",
      "guardianRelationship": "Parentesco",
      "notes": "Observações"
    },
    "address": {
      "search": "Buscar",
      "noResults": "Nenhum resultado.",
      "cityNeedsState": "Escolha o estado primeiro."
    },
    "options": {
      "none": "Não informado",
      "sex": {
        "female": "Feminino",
        "male": "Masculino",
        "intersex": "Intersexo"
      },
      "marital": {
        "single": "Solteiro(a)",
        "married": "Casado(a)",
        "stable_union": "União estável",
        "separated": "Separado(a)",
        "divorced": "Divorciado(a)",
        "widowed": "Viúvo(a)"
      }
    },
    "form": {
      "title": "Editar {{card}}",
      "save": "Salvar",
      "saveAnyway": "Salvar mesmo assim",
      "cancel": "Cancelar",
      "open": "Abrir cadastro",
      "errors": {
        "required": "Preencha este campo.",
        "cpfInvalid": "CPF inválido. Confira os 11 dígitos.",
        "birthDateInvalid": "Data inválida. Use uma data entre 1900 e hoje.",
        "phoneInvalid": "Telefone inválido. Informe o DDD, ou o código do país com +.",
        "emailInvalid": "E-mail inválido.",
        "postalCodeInvalid": "CEP inválido. Informe 8 dígitos.",
        "cityNotInState": "Escolha uma cidade do estado selecionado.",
        "countryInvalid": "Informe 2 letras, como BR.",
        "notesTooLong": "Use no máximo 2000 caracteres.",
        "contactRequired": "Informe um telefone ou um e-mail.",
        "cpfTaken": "Este CPF já está cadastrado para {{name}}.",
        "cpfTakenArchived": "Este CPF já está cadastrado para {{name}} (cadastro arquivado)."
      },
      "failed": "Não foi possível salvar. Tente novamente.",
      "archived": "Este cadastro foi arquivado e não pode mais ser editado.",
      "duplicates": {
        "title": "Existem cadastros parecidos",
        "body": "Confira antes de salvar. O botão agora é “Salvar mesmo assim”.",
        "nameBirthDate": "mesmo nome e data de nascimento",
        "phone": "mesmo telefone",
        "archivedTag": "arquivado",
        "open": "Abrir cadastro de {{name}}"
      }
    }
  },
  "hub.patientAlerts": {
    "title": "Alertas clínicos",
    "empty": "Nenhum alerta clínico.",
    "meta": "{{name}} em {{at}}",
    "add": "Adicionar alerta",
    "resolve": "Resolver",
    "resolveLabel": "Resolver alerta: {{text}}",
    "resolved": "Alerta resolvido.",
    "added": "Alerta adicionado.",
    "chips": "Alertas clínicos ativos",
    "addDialog": {
      "title": "Adicionar alerta clínico",
      "text": "Alerta",
      "hint": "Um aviso curto para toda a equipe, como “Alergia a penicilina”. Até 500 caracteres.",
      "save": "Adicionar",
      "cancel": "Cancelar",
      "required": "Escreva o alerta.",
      "tooLong": "Use no máximo 500 caracteres.",
      "failed": "Não foi possível adicionar o alerta. Tente novamente.",
      "archived": "Este cadastro foi arquivado e não pode mais ser alterado."
    },
    "resolveDialog": {
      "title": "Resolver alerta clínico",
      "body": "Este alerta deixará de aparecer no cadastro: “{{text}}”",
      "confirm": "Resolver alerta",
      "cancel": "Cancelar",
      "failed": "Não foi possível resolver o alerta. Tente novamente.",
      "archived": "Este cadastro foi arquivado e não pode mais ser alterado."
    }
  },
  "hub.patientPrivacy": {
    "title": "Privacidade e LGPD",
    "intro": "Base legal, aviso de privacidade e consentimentos deste paciente. Nada aqui bloqueia o atendimento.",
    "loading": "Carregando a privacidade…",
    "failed": "Não foi possível carregar a privacidade. Tente novamente.",
    "saved": "Registro salvo.",
    "none": "Sem registro",
    "basis": {
      "title": "Base legal do prontuário",
      "none": "Nenhuma base legal registrada.",
      "summary": "{{basis}}, desde {{date}}, registrada por {{name}}.",
      "change": "Alterar base legal",
      "options": {
        "health_protection": "Tutela da saúde",
        "legal_obligation": "Obrigação legal ou regulatória",
        "contract": "Execução de contrato",
        "consent": "Consentimento",
        "other_documented": "Outra, documentada"
      }
    },
    "notice": {
      "title": "Aviso de privacidade",
      "none": "Ciência do aviso ainda não registrada. O atendimento segue normalmente.",
      "summary": "Ciência registrada em {{date}}: {{givenBy}}, {{channel}}. Registrada por {{name}}.",
      "record": "Registrar ciência do aviso",
      "recordAgain": "Registrar nova ciência"
    },
    "consents": {
      "title": "Consentimentos além do atendimento",
      "hint": "O prontuário não depende de consentimento. Registre aqui apenas usos opcionais.",
      "purposeLabel": "Finalidade",
      "stateLabel": "Situação",
      "given": "Concedido em {{date}}",
      "withdrawn": "Retirado em {{date}}",
      "give": "Registrar consentimento",
      "giveFor": "Registrar consentimento: {{purpose}}",
      "withdraw": "Registrar retirada",
      "withdrawFor": "Registrar retirada: {{purpose}}",
      "purposes": {
        "care_record": "Prontuário",
        "marketing": "Comunicações de marketing",
        "case_showcase_images": "Divulgação de imagens de casos",
        "research": "Pesquisa"
      }
    },
    "history": {
      "summary": "Histórico ({{count}})",
      "empty": "Nenhum evento registrado.",
      "kinds": {
        "legal_basis_set": "Base legal definida: {{basis}}",
        "notice_acknowledged": "Ciência do aviso registrada",
        "consent_given": "Consentimento concedido: {{purpose}}",
        "consent_withdrawn": "Consentimento retirado: {{purpose}}"
      },
      "meta": "{{date}}, por {{name}}",
      "wording": "Versão do texto: {{version}}"
    },
    "givenBy": {
      "patient": "o paciente",
      "guardian": "o responsável legal"
    },
    "channel": {
      "written": "por escrito",
      "electronic": "por meio eletrônico"
    },
    "form": {
      "titles": {
        "legal_basis_set": "Alterar base legal",
        "notice_acknowledged": "Registrar ciência do aviso",
        "consent_given": "Registrar consentimento: {{purpose}}",
        "consent_withdrawn": "Registrar retirada: {{purpose}}"
      },
      "basis": "Base legal",
      "givenBy": "Quem informou",
      "channel": "Como foi registrado",
      "wording": "Versão do texto apresentado",
      "occurredOn": "Data",
      "note": "Observação",
      "noteHint": "Sem informações de saúde aqui.",
      "submit": "Registrar",
      "cancel": "Cancelar",
      "errors": {
        "dateRequired": "Informe a data.",
        "dateFuture": "A data não pode ser futura.",
        "noteRequired": "Explique a base documentada.",
        "noteTooLong": "Use no máximo 500 caracteres."
      },
      "failed": "Não foi possível registrar. Tente novamente.",
      "noConsent": "Não há consentimento concedido para retirar nessa data."
    }
  },
  "hub.patientCreate": {
    "title": "Novo paciente",
    "save": "Salvar",
    "saveAnyway": "Salvar mesmo assim",
    "cancel": "Cancelar",
    "openUnarchive": "Abrir e desarquivar",
    "failed": "Não foi possível cadastrar o paciente. Tente novamente.",
    "loading": "Carregando…",
    "loadFailed": "Não foi possível carregar o formulário. Tente novamente.",
    "noAccess": "Você não tem permissão para cadastrar pacientes.",
    "toast": {
      "title": "Paciente cadastrado"
    }
  },
  "hub.patientList": {
    "title": "Pacientes",
    "subtitle": "Cadastro de pacientes da clínica.",
    "new": "Novo paciente",
    "filter": {
      "label": "Situação",
      "active": "Ativos",
      "all": "Incluir arquivados"
    },
    "search": {
      "label": "Buscar paciente",
      "placeholder": "Buscar por nome, CPF ou telefone…"
    },
    "sort": {
      "menu": "Ordenar: {{current}}",
      "label": "Ordenar por",
      "name": "Nome (A–Z)",
      "createdAt": "Adicionados recentemente",
      "updatedAt": "Atualizados recentemente"
    },
    "col": {
      "patient": "Paciente",
      "contact": "Contato",
      "cpf": "CPF",
      "actions": "Ações"
    },
    "birthDate": "Nascimento: {{date}}",
    "birthDateMissing": "Nascimento não informado",
    "contactMissing": "Não informado",
    "cpfMissing": "Não informado",
    "archived": "Arquivado",
    "open": "Ver prontuário",
    "openFor": "Ver prontuário de {{name}}",
    "loadMore": "Carregar mais",
    "loading": "Carregando pacientes…",
    "empty": {
      "title": "Nenhum paciente cadastrado",
      "hint": "Cadastre o primeiro paciente da clínica."
    },
    "noResults": {
      "title": "Nenhum paciente encontrado",
      "hint": "Tente outro termo.",
      "hintArchived": "Tente outro termo ou inclua os arquivados."
    },
    "announce": {
      "shown_one": "{{count}} paciente exibido",
      "shown_other": "{{count}} pacientes exibidos",
      "loadedMore_one": "{{count}} paciente carregado, {{shown}} exibidos",
      "loadedMore_other": "{{count}} pacientes carregados, {{shown}} exibidos",
      "none": "Nenhum paciente encontrado"
    },
    "error": {
      "load": "Não foi possível carregar os pacientes. Tente novamente.",
      "more": "Não foi possível carregar mais pacientes. Tente novamente."
    }
  },
  "hub.clinicSettings": {
    "title": "Configurações da clínica",
    "subtitle": "Horário de funcionamento e identidade da clínica.",
    "loading": "Carregando configurações…",
    "loadFailed": "Não foi possível carregar as configurações da clínica.",
    "retry": "Tentar novamente",
    "notInformed": "Não informado",
    "weekday": {
      "1": "Segunda-feira",
      "2": "Terça-feira",
      "3": "Quarta-feira",
      "4": "Quinta-feira",
      "5": "Sexta-feira",
      "6": "Sábado",
      "7": "Domingo"
    },
    "common": {
      "cancel": "Cancelar",
      "save": "Salvar"
    },
    "hours": {
      "title": "Horário de funcionamento",
      "tableLabel": "Horário de funcionamento por dia",
      "colDay": "Dia",
      "colHours": "Horário",
      "closed": "Fechado",
      "interval": "{{opensAt, time}} às {{closesAt, time}}",
      "notSet": "Não definido",
      "notSetOwner": "O horário de funcionamento ainda não foi definido. Enquanto isso, a agenda mostra o período das {{from, time}} às {{to, time}} e não avisa sobre horários fora do expediente.",
      "notSetMember": "O proprietário da clínica ainda não definiu o horário de funcionamento. Enquanto isso, a agenda mostra o período das {{from, time}} às {{to, time}}.",
      "define": "Definir horário",
      "edit": "Editar horário",
      "saved": "Horário de funcionamento salvo",
      "form": {
        "opens": "Abre às",
        "closes": "Fecha às",
        "add": "Adicionar intervalo",
        "addFor": "Adicionar intervalo: {{day}}",
        "remove": "Remover",
        "removeFor": "Remover intervalo, {{day}}, {{opensAt, time}} às {{closesAt, time}}",
        "removeBlankFor": "Remover intervalo {{n}} sem horário, {{day}}",
        "caption": "Horário de funcionamento, um intervalo por linha",
        "colActions": "Ações",
        "opensFor": "Abre às, {{day}}",
        "closesFor": "Fecha às, {{day}}",
        "intervalSuffix": ", intervalo {{n}}",
        "hint": "Use horários de 5 em 5 minutos. Para um intervalo de almoço, adicione dois intervalos no mesmo dia. Um dia sem intervalos fica fechado.",
        "failed": "Não foi possível salvar o horário. Tente novamente.",
        "errors": {
          "week": "Informe ao menos um intervalo de funcionamento.",
          "incomplete": "Informe a abertura e o fechamento.",
          "grid": "Use horários de 5 em 5 minutos.",
          "order": "O fechamento deve ser depois da abertura.",
          "overlap": "Este intervalo se sobrepõe a outro no mesmo dia."
        }
      }
    },
    "identity": {
      "title": "Identidade da clínica",
      "edit": "Editar identidade",
      "saved": "Identidade da clínica salva",
      "hint": "Os dados que os documentos da clínica imprimem. Todos são opcionais.",
      "whatsapp": "WhatsApp",
      "cro": "CRO {{number}}/{{uf}}",
      "croNoUf": "CRO {{number}}",
      "form": {
        "failed": "Não foi possível salvar a identidade. Tente novamente.",
        "whatsapp": "Este telefone tem WhatsApp",
        "none": "Nenhum",
        "candidate": "{{name}} — CRO {{cro}}",
        "managerHint": "Escolha entre os membros com a função de dentista e CRO cadastrado.",
        "managerNone": "Nenhum membro é dentista com CRO cadastrado.",
        "cityNeedsState": "Escolha o estado primeiro.",
        "search": "Buscar",
        "noResults": "Nenhum resultado.",
        "errors": {
          "required": "Informe o nome fantasia.",
          "cnpjLength": "CNPJ incompleto. Informe os 14 caracteres.",
          "cnpjChecksum": "CNPJ inválido. Os dígitos verificadores não conferem, confira o número.",
          "phoneInvalid": "Telefone inválido. Informe o DDD e o número.",
          "emailInvalid": "E-mail inválido.",
          "postalCodeInvalid": "CEP inválido. Informe os 8 dígitos.",
          "cityNeedsState": "Escolha um município do estado selecionado."
        }
      },
      "fields": {
        "name": "Nome fantasia",
        "legalName": "Razão social",
        "cnpj": "CNPJ",
        "croRegistration": "Inscrição CRO da clínica",
        "phone": "Telefone",
        "email": "E-mail",
        "address": "Endereço",
        "postalCode": "CEP",
        "street": "Rua",
        "number": "Número",
        "complement": "Complemento",
        "district": "Bairro",
        "state": "UF",
        "city": "Cidade",
        "technicalManager": "Responsável técnico"
      }
    }
  },
  "hub.schedule": {
    "title": "Horários e bloqueios",
    "loading": "Carregando horários e bloqueios…",
    "loadFailed": "Não foi possível carregar os horários e bloqueios.",
    "retry": "Tentar novamente",
    "close": "Fechar",
    "back": "Voltar",
    "cancel": "Cancelar",
    "save": "Salvar",
    "weekday": {
      "1": "Segunda-feira",
      "2": "Terça-feira",
      "3": "Quarta-feira",
      "4": "Quinta-feira",
      "5": "Sexta-feira",
      "6": "Sábado",
      "7": "Domingo"
    },
    "reason": {
      "vacation": "Férias",
      "absence": "Ausência",
      "training": "Capacitação",
      "holiday": "Feriado",
      "closure": "Fechamento",
      "other": "Outro"
    },
    "status": {
      "scheduled": "Agendado",
      "confirmed": "Confirmado",
      "arrived": "Chegou",
      "in_progress": "Em atendimento",
      "completed": "Concluído",
      "cancelled": "Cancelado",
      "no_show": "Faltou"
    },
    "hours": {
      "title": "Horário de atendimento",
      "professional": "Profissional",
      "noProfessionals": "Nenhum profissional ativo nesta clínica.",
      "notSet": "Não definido",
      "notSetText": "{{name}} não tem horário próprio e segue o horário de funcionamento da clínica.",
      "tableLabel": "Horário de atendimento por dia",
      "colDay": "Dia",
      "colHours": "Horário",
      "closed": "Não atende",
      "interval": "{{opensAt, time}} às {{closesAt, time}}",
      "define": "Definir horário",
      "edit": "Editar horário",
      "saved": "Horário de atendimento salvo",
      "form": {
        "title": "Horário de atendimento: {{name}}",
        "hint": "Use horários de 5 em 5 minutos. Para uma pausa de almoço, adicione dois intervalos no mesmo dia. Um dia sem intervalos é um dia em que o profissional não atende. O horário pode ficar fora do funcionamento da clínica.",
        "opens": "Começa às",
        "closes": "Termina às",
        "add": "Adicionar intervalo",
        "addFor": "Adicionar intervalo: {{day}}",
        "remove": "Remover",
        "removeFor": "Remover intervalo, {{day}}, {{opensAt, time}} às {{closesAt, time}}",
        "removeBlankFor": "Remover intervalo {{n}} sem horário, {{day}}",
        "caption": "Horário de atendimento, um intervalo por linha",
        "colActions": "Ações",
        "opensFor": "Começa às, {{day}}",
        "closesFor": "Termina às, {{day}}",
        "intervalSuffix": ", intervalo {{n}}",
        "failed": "Não foi possível salvar o horário. Tente novamente.",
        "forbidden": "Você não pode alterar o horário deste profissional.",
        "notEligible": "Este profissional não atende mais nesta clínica.",
        "errors": {
          "week": "Informe ao menos um intervalo de atendimento.",
          "incomplete": "Informe o início e o fim.",
          "grid": "Use horários de 5 em 5 minutos.",
          "order": "O fim deve ser depois do início.",
          "overlap": "Este intervalo se sobrepõe a outro no mesmo dia."
        }
      }
    },
    "blocks": {
      "title": "Bloqueios",
      "new": "Novo bloqueio",
      "empty": "Nenhum bloqueio futuro.",
      "clinic": "Toda a clínica",
      "showPast": "Ver bloqueios passados",
      "pastTitle": "Bloqueios passados",
      "pastEmpty": "Nenhum bloqueio passado.",
      "pastFailed": "Não foi possível carregar os bloqueios passados.",
      "edit": "Editar",
      "editFor": "Editar bloqueio: {{who}}, {{dates}}",
      "remove": "Excluir",
      "removeFor": "Excluir bloqueio: {{who}}, {{dates}}",
      "reasonLabel": "{{reason}}: {{label}}",
      "dates": {
        "day": "{{date}}",
        "days": "{{start}} a {{end}}",
        "timed": "{{date}}, {{start, time}} às {{end, time}}",
        "timedDays": "{{startDate}} {{start, time}} a {{endDate}} {{end, time}}"
      },
      "created": "Bloqueio criado",
      "updated": "Bloqueio salvo",
      "deleted": "Bloqueio excluído",
      "form": {
        "titleNew": "Novo bloqueio",
        "titleEdit": "Editar bloqueio",
        "who": "Quem",
        "reason": "Motivo",
        "label": "Descrição (opcional)",
        "labelHint": "Aparece na agenda. Não escreva dados de saúde nem de pacientes.",
        "allDay": "Dia(s) inteiro(s)",
        "firstDay": "Primeiro dia",
        "lastDay": "Último dia",
        "startDate": "Data inicial",
        "startTime": "Hora inicial",
        "endDate": "Data final",
        "endTime": "Hora final",
        "create": "Criar bloqueio",
        "save": "Salvar bloqueio",
        "failed": "Não foi possível salvar o bloqueio. Tente novamente.",
        "forbidden": "Você não pode alterar este bloqueio.",
        "notEligible": "Este profissional não atende mais nesta clínica.",
        "notFound": "Este bloqueio não existe mais. Feche e abra novamente.",
        "errors": {
          "required": "Preencha este campo.",
          "grid": "Use horários de 5 em 5 minutos.",
          "order": "A data final deve ser igual ou posterior à inicial.",
          "orderTime": "A hora final deve ser depois da inicial.",
          "invalid": "Este horário não existe no fuso da clínica.",
          "labelTooLong": "A descrição pode ter no máximo 80 caracteres."
        }
      },
      "warn": {
        "title_one": "Este bloqueio cobre {{count}} agendamento",
        "title_other": "Este bloqueio cobre {{count}} agendamentos",
        "hint": "Os agendamentos continuam como estão e passam a aparecer como \"em um bloqueio\". Mova ou cancele cada um depois.",
        "listLabel": "Agendamentos cobertos",
        "item": "{{date}}, {{start, time}} às {{end, time}}: {{patient}} com {{professional}} ({{status}})",
        "more_one": "e mais {{count}} agendamento",
        "more_other": "e mais {{count}} agendamentos",
        "confirmCreate": "Criar mesmo assim",
        "confirmSave": "Salvar mesmo assim",
        "adjust": "Voltar e ajustar"
      },
      "delete": {
        "title": "Excluir bloqueio?",
        "body": "O bloqueio {{summary}} será excluído e o horário volta a ficar disponível.",
        "confirm": "Excluir",
        "failed": "Não foi possível excluir o bloqueio. Tente novamente."
      }
    }
  },
  "public.header": {
    "login": "Entrar"
  },
  "public.shell": {
    "skipToContent": "Pular para o conteúdo"
  },
  "public.accessibility": {
    "title": "Declaração de acessibilidade",
    "commitment": {
      "title": "Nosso compromisso",
      "body": "A Takove quer que o sistema possa ser usado por todas as pessoas, inclusive pessoas com deficiência e quem usa leitor de tela, teclado ou ampliação de tela."
    },
    "standard": {
      "title": "Padrão e avaliação",
      "body": "Buscamos seguir a WCAG 2.2, nível AA. Esta é uma autoavaliação; o sistema ainda não passou por auditoria independente e não declaramos conformidade."
    },
    "gaps": {
      "title": "Limitações conhecidas",
      "body": "Estamos reconstruindo a interface. Hoje a área pública tem apenas a página inicial, esta declaração e a página de erro, e não conhecemos barreiras nelas. As telas da área restrita, como a agenda abaixo, e as demais telas entram à medida que são reconstruídas, com as mesmas verificações automáticas, que não substituem uma auditoria independente.",
      "agenda": "A agenda da clínica (área restrita, nas visões em lista e em grade) passa por verificações automáticas (axe, WCAG 2.2 AA) e por testes de teclado. Ela ainda não foi testada com leitores de tela (VoiceOver e NVDA) nem em dispositivos reais com zoom. A grade é uma tabela com botões, sem o papel ARIA de grade, até esse teste ser feito; a lista é a alternativa e a visão padrão em telas pequenas."
    },
    "contact": {
      "title": "Contato",
      "body": "Encontrou uma barreira ou precisa de outro formato? Escreva para:"
    },
    "lastReviewed": "Última revisão: 30 de outubro de 2026"
  },
  "public.home": {
    "hero": {
      "title": "Olá, mundo",
      "tagline": "Fastify + React + daisyUI"
    }
  },
  "public.notFound": {
    "title": "Página não encontrada",
    "message": "A página que você procurou não existe ou foi movida.",
    "home": "Ir para o início"
  },
  "app.footer": {
    "tagline": "Uma entrada simples para encontrar cuidado, profissionais e produtos.",
    "navigation": "Links do rodapé",
    "accessibility": "Acessibilidade",
    "hub": "Hub",
    "admin": "Admin",
    "build": "Versão {{id}}"
  },
  "app.brand": {
    "name": "Takove"
  },
  "forgotPassword": {
    "title": "Esqueceu a senha?",
    "intro": "Informe o e-mail da sua conta e enviaremos um link para definir uma nova senha.",
    "email": "E-mail",
    "submit": "Enviar link",
    "back": "Voltar para entrar",
    "sent": "Se existir uma conta para este endereço, enviamos um link.",
    "error": {
      "throttled": "Muitas tentativas. Aguarde alguns minutos e tente novamente.",
      "failed": "Não foi possível enviar o link. Tente novamente."
    }
  },
  "setPassword": {
    "title": "Definir senha",
    "checking": "Verificando o link…",
    "email": "E-mail",
    "password": "Nova senha",
    "confirm": "Confirmar nova senha",
    "submit": "Definir senha",
    "invalid": {
      "title": "Link inválido ou expirado",
      "message": "Este link de definição de senha não é válido ou já expirou.",
      "forgot": "Solicitar um novo link"
    },
    "error": {
      "tooShort": "A senha precisa ter pelo menos {{min}} caracteres.",
      "mismatch": "As senhas não coincidem.",
      "throttled": "Muitas tentativas. Aguarde um minuto e tente novamente.",
      "generic": "Não foi possível definir a senha. Tente novamente."
    }
  },
  "i18n.localeSelect": {
    "label": "Idioma"
  },
  "common": {
    "save": "Salvar",
    "cancel": "Cancelar",
    "edit": "Editar",
    "delete": "Excluir",
    "close": "Fechar",
    "loading": "Carregando…",
    "fallbackProbe": "Sondagem",
    "errorBoundary": {
      "title": "Algo deu errado",
      "message": "Ocorreu um erro inesperado. Tente recarregar a página.",
      "reload": "Recarregar a página",
      "home": "Ir para o início"
    }
  }
}
